module.exports = __webpack_public_path__ + "logo-huawei/logo-huawei-a5f245c17c398afeee1192225dd45fdb.svg";